<template lang="pug">
	.widgets-area.segment
		ProductSelectionComponent(:items="products", :selectedValues="data.products", @add="onAdd", @remove="onRemove")
</template>

<script>
	import _ from 'lodash';
	import VueTypes from 'vue-types';
	import ProductSelectionComponent from './ProductSelectionComponent.vue';

	export default {
		translationCategory: 'proposal.ProductSelection',
		name: 'product-selection',
		components: {ProductSelectionComponent},
		props: {
			data: VueTypes.object.def({}),
			products: VueTypes.array.def([])
		},
		mounted() {
			if (__DEBUG__)
				console.log('Product selection mounted', this);
		},
		methods: {
			onAdd(oid) {
				this.ensureProd(oid);
			},
			onRemove(oid) {
				this.data.productsInfo.splice(_.findIndex(this.data.productsInfo, (v) => v.oid === oid), 1);
			},
			ensureProd(oid) {
				var prod = this.data.productsInfo.filter(f => f.oid === oid)[0];
				if (!prod) {
					prod = {
						oid,
						podcasts: [],
						streamings: []
					};
					this.data.productsInfo.push(prod);
				}
			}
		}
	};
</script>
<style lang='scss'>
	.product-selection {
	}
</style>
